import { render, staticRenderFns } from "./search-filter.vue?vue&type=template&id=3566793e&scoped=true"
import script from "./search-filter.vue?vue&type=script&lang=js"
export * from "./search-filter.vue?vue&type=script&lang=js"
import style0 from "./search-filter.vue?vue&type=style&index=0&id=3566793e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3566793e",
  null
  
)

export default component.exports